import { LifeUpdater } from "./LifeUpdater.js";
export async function loadLifeUpdater(engine, refresh = true) {
    await engine.addParticleUpdater("life", (container) => new LifeUpdater(container), refresh);
}
